/** Trigger a browser download for the given Blob under the supplied file name. */
export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // Revoke after a tick so the browser can pick up the click.
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
